import http from "lib/http";
import { SERVER_URL } from "./global";

export const serverGet = ({
  url = "",
  data = {},
  onFinish = () => {},
  onLoading = () => {},
  ...params
}) => {
  http
    .get(`${SERVER_URL}/api/${url}`, data ?? {})
    .then(({ data: response }) => {
      onFinish(response);
      onLoading(false);
    })
    .catch((err) => {
      onLoading(false);
      console.log(err?.response?.data);
      onFinish(false, err?.response?.data);
    });
};

// url, data,
export const serverPost = ({
  url = "",
  data = {},
  onLoading = () => {},
  onFinish = () => {},
  ...params
}) => {
  onLoading(true);
  http
    .post(`${SERVER_URL}/api/${url}`, data ?? {})
    .then(({ data: response }) => {
      onFinish(response);
      onLoading(false);
    })
    .catch((err) => {
      onLoading(false);
      onFinish(false, err?.response?.data);
    });
};
